import React, { useEffect } from "react";
import { withRouter } from 'react-router-dom';

import useDfpSlot from './useDfpSlot';

import '../App.scss';

function Modal(props) {
  // console.log('modal props:', props)
  useDfpSlot({
    path: '/6674/stuff.wholetruth',
    id: `div-gpt-ad-8564960-${props.activeModalData.id}`,
  });
  
  // console.log('modal index: ',props.activeModalData.id)

  useEffect(() => {
    var twitterLib = "https://platform.twitter.com/widgets.js";
    var twitterEmbed = document.querySelector('.twitter-tweet');
    // var flourishLib = "https://public.flourish.studio/resources/embed.js";

    // loadtwitter script initially for loading 
    if (!isLoadedScript(twitterLib)) {
      loadScript(twitterLib);
    } 
    if(isLoadedScript(twitterLib)) {
          // if twitter script is already loaded, and the component is a Twitter embed, ask Twitter library to re-start the Twitter widgets
          if (twitterEmbed && window.twttr) {
             window.twttr.widgets.load();
          }
        }
       
    }
  )

  var isLoadedScript = (lib) => {
    return document.querySelectorAll('[src="' + lib + '"]').length > 0
  }

  var loadScript = (lib) => {
    var script = document.createElement('script');
    script.setAttribute('src', lib);
    script.async = true;
    document.getElementsByTagName('head')[0].appendChild(script);
    return script;
  }

  // share bar in post
  var getWindowDim =  () => {
    let width = Math.min(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
      ),
      height = Math.min (
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.documentElement.clientHeight,
        window.innerHeight
      );
    return { width: width, height: height};
  }

  var fbLink = (e) => {
    e.preventDefault();
    let windowWidth = getWindowDim().width,
        left = ( windowWidth - 600) / 2,
        fbURL = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent("https://interactives.stuff.co.nz/2020/08/election-2020-the-whole-truth/#/" +props.location.pathname);
    if(windowWidth > 840) {
      window.open(fbURL, 'facebook', 'width=600, height=450, top=200, left=' + left);
    } else {
      window.open(fbURL);
    }
  }

  var twitterLink = (e) => {
    e.preventDefault();
    let windowWidth = getWindowDim().width,
        left = (windowWidth - 600) / 2,
        twitURL = "https://twitter.com/intent/tweet?url=" + encodeURIComponent("https://interactives.stuff.co.nz/2020/08/election-2020-the-whole-truth/#" + props.location.pathname) + "&text=" + encodeURIComponent(props.activeModalData.title) + "&via=NZSTUFF";
    if(windowWidth > 840) {
      window.open(twitURL, 'twitter', 'width=600, height=450, top=200, left=' + left);
    } else {
      window.open(twitURL);
    }
  }
  
    return (
      <React.Fragment>
        {props.show && (
          <div className="modalwrapper">
            <div className="modalwrapper--modalbox">
              <span className="modal-button-box--close---top" onClick={props.onHide}>&#10005;</span>
              <div className="modalwrapper--modalbox---titlebox">
                <div className="modalwrapper--modalbox---titlebox--label-sharebox">
                <span className={`label-index label-index--${props.activeModalData.label}`}>{props.activeModalData.label}</span>
                  <div className="modalwrapper-container__sharebar">
                  {/* eslint-disable-next-line */}
                  <a onClick={fbLink} className="modalwrapper-container__sharebar--FB"></a>
                  {/* eslint-disable-next-line */}
                  <a onClick={twitterLink} className="modalwrapper-container__sharebar--TW"></a>
                  </div>
                </div>
                <h1 className="modalwrapper--modalbox---titlebox--title">{props.activeModalData.title}</h1>
                <div className="modalwrapper--modalbox--donation-box">
                Support independent, trustworthy coverage of politics and the election by <a rel="noopener noreferrer"  href="https://interactives.stuff.co.nz/2020/03/support-stuffs-journalism/" target="_blank">making a contribution</a>.
                </div>
              </div>
              <div className="modalwrapper--modalbox---content" dangerouslySetInnerHTML={{__html: props.activeModalData.postBody}}></div>
              {/* <div className="modalwrapper--modalbox---credit">
                <img className="modalwrapper--modalbox---credit--pic"alt={props.activeModalData.autor} src={props.activeModalData.autorPic}/>
                <span className="modalwrapper--modalbox---credit--name">{props.activeModalData.autor}</span>
                </div> */}
              <div className="modal-button-box">
                <span className={props.disabledNewButton ? "modal-button-box--disabledButton" : "modal-button-box--newpostButton"} onClick={props.newClick}>Newer Posts</span> 
                <span className="modal-button-box--close" onClick={props.onHide}>Home</span>
                <span className={props.disabledOldButton ? "modal-button-box--disabledButton" :"modal-button-box--oldpostButton"} onClick={props.oldClick}>Older Posts</span>
              </div>
                {/* ads start */}
              <div className='ads-wrap-container'>
              <div id={`div-gpt-ad-8564960-${props.activeModalData.id}`}>
                
              </div>
              </div>
              {/* ads end */}
            </div>
          </div>
        )}
      </React.Fragment>
    );
}

export default withRouter(Modal);
